import React from 'react'

import WithdrawingWallet from './WithdrawingWallet'
import WithdrawingHistory from './WithdrawingHistory'

const Withdrawing = () => {
  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Withdrawing
      </h3>

      <div className="w-full mt-[20px] bg-[#FEEBDD] rounded-[10px] py-[64px] px-[48px]">
        <WithdrawingWallet />
        <WithdrawingHistory />
      </div>
    </div>
  )
}

export default Withdrawing
